<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>


<div class="container-fluid" style="overflow-y:auto;padding:0px;">
    <div class="container-fluit">
        <div class="row" style="display: block;">

            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 content ranking-div3"
                style="padding:0.3rem 0px 0px  11px !important;overflow-y:auto;">

                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding:0px">
                    <div>
                        <div class="row" style="padding-top:6px;text-align:right;display: block;">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"
                                style="float:right;padding:0px 2px">

                                <div class="example-container">
                                    <label>انتخاب سال</label>
                                    <select class="wh-input" name="year_id" [(ngModel)]="year_id"
                                        (change)="get_ranking_year(year_id)">
                                        <option *ngFor="let x of list_year" [value]="x.id"
                                            (click)="select_month(year_id,month_id);">
                                            {{ x.title }}
                                        </option>
                                    </select>
                                </div>

                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12" style="padding:0px 2px">
                                <label>انتخاب ماه</label>
                                <select class="wh-input" name="month_id" [(ngModel)]="month_id">
                                    <option *ngFor="let x of list_month" [value]="x.site_month_value"
                                        (click)="select_month(year_id,x.site_month_value)">
                                        {{x.site_month_title }}
                                    </option>
                                </select>


                            </div>
                        </div>



                    </div><!-- end  -->
                </div>

            </div><!-- -->


            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-xs-12 ranking-div4"
                style="padding:0rem 0 0 0 !important">
                <div class="row example content" style="margin:14px !important;overflow-y:scroll;padding-bottom:2rem">

                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding:0">
                            <div style="background:#fff;padding-top:0.5rem;margin-bottom:1rem">
                                <highcharts-chart [Highcharts]="Highcharts" [options]="{
                                title : { text : 'میزان ورودی ماهانه' + year_id  },
                                chart : {type: 'column'},
                                tooltip : tooltip2,
                                xAxis : {categories: list_score_month_text,crosshair: true},
                                yAxis : {min: 0,title: {text: 'فروش ماهانه'}},
                                legend: {
                                    enabled: false
                                },
                                series : [
                                { 
                                    name: 'Browsers',
                                    colorByPoint: true,
                                    type:'column',
                                    data: list_score_branch_monthly
                                } 
                                ]
                                
                            }" style="width: 100%; height: 300px; display: block;padding-top: 1rem;">
                                </highcharts-chart>
                            </div>
                        </div>
                    </div><!-- row -->

                    <div class="row" style="margin-bottom:1rem">
                        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            style="padding: 0;padding-right:3px;">


                            <div class="div_chart2">
                                <highcharts-chart [Highcharts]="Highcharts" [options]="{
                                    title : { text : ' نمودار فروش'   },
                                    tooltip : tooltip5,
                                    plotOptions : {
                                        pie: {
                                        allowPointSelect: true,
                                        cursor: 'pointer',
                                        dataLabels: {
                                            enabled: true,
                                            style: {
                                            }
                                        }
                                        }
                                    },
                                    series : [{
                                    name : 'فروش',
                                    data : list_sale,
                                    type : 'pie'
                                    }] 
                                    }" style="width: 100%; height: 300px; display: block;">
                                </highcharts-chart>
                            </div>


                            <div class="div_chart1" *ngIf="list_sale.length == 0">
                                موردی برای نمایش وجود ندارد
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"
                            style="padding:0px;padding-left:3px;">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6" style="padding:0px">
                                <div class="div_saco4">
                                    <div class="div_saco6" (click)="get_count_invoice(year_id)">
                                        تعداد فاکتور سال
                                    </div>
                                    <div class="div_saco7">
                                        {{ count_invoice }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6" style="padding:0px">
                                <div class="div_saco5">
                                    <div class="div_saco8" (click)="get_count_customer(year_id)">
                                        مشتریان وارد شده به شرکت امسال
                                    </div>
                                    <div class="div_saco9">
                                        {{ count_customer }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            style="padding:0;margin-bottom:1rem">
                            <div style="background:#fff;padding-top:0.5rem">
                                <highcharts-chart [Highcharts]="Highcharts" [options]="{
                                    title : { text :  ' نمودار پورسانت  ' +  user_store },
                                    chart : {type: 'area'},
                                    tooltip : tooltip4, 
                                    xAxis : {categories: list_score_month_text,crosshair: true},
                                    yAxis : {min: 0,title: {text: 'فروش ماهانه'}},
                                    legend: {
                                        enabled: false
                                    },
                                    series : [{
                                        name:  'سال ' + year_id, 
                                        colorByPoint: true,
                                        type:'column',
                                        data: list_score_branch_data
                                    }]
                                    
                                }" style="width: 100%; height: 300px; display: block;padding-top: 1rem;">
                                </highcharts-chart>
                            </div>
                        </div>
                    </div>
                    <!-- ----------------------------------------------------------------------------- -->


                </div>
            </div>


        </div>



    </div>
</div>